import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { topics } from '@/mocks/topics';

export default function LatestTopics() {
  const [headline, ...rest] = topics;
  const sideList = rest.slice(0, 4);

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="秘史专题"
          title="近期更新的深度专题"
          description="每篇专题都会把论证过程一起写出来：用了哪些材料、哪些地方存在分歧、哪些结论仍然存疑，读完之后你可以自己判断。"
          action={
            <Link
              to="/topics"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-900"
            >
              全部专题
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          }
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-[1.1fr_0.9fr]">
          <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <Link
              to={`/topics/${headline.slug}`}
              className="block h-56 w-full overflow-hidden bg-background-200 md:h-72"
            >
              <img
                src={headline.cover}
                alt={`${headline.title} 专题配图`}
                title={`${headline.title} · 秘史专题`}
                className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-[1.03]"
              />
            </Link>
            <div className="flex flex-1 flex-col p-6">
              <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                <span className="rounded-full bg-accent-100 px-2.5 py-0.5 font-medium text-accent-800">
                  {headline.category}
                </span>
                <span>{headline.date}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {headline.readTime}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                <Link
                  to={`/topics/${headline.slug}`}
                  className="transition-colors hover:text-primary-800"
                >
                  {headline.title}
                </Link>
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                {headline.excerpt}
              </p>
              <div className="mt-5 flex flex-wrap items-center justify-between gap-3 border-t border-background-200 pt-4">
                <span className="text-xs text-foreground-500">{headline.author}</span>
                <Link
                  to={`/topics/${headline.slug}`}
                  className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-900"
                >
                  阅读专题
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-4">
            {sideList.map((topic) => (
              <article
                key={topic.id}
                className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-secondary-300"
              >
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 font-heading text-xs font-bold text-secondary-800">
                  {topic.date.slice(5).replace('-', '/')}
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading text-sm font-semibold leading-snug text-foreground-950">
                    <Link
                      to={`/topics/${topic.slug}`}
                      className="transition-colors hover:text-primary-800"
                    >
                      {topic.title}
                    </Link>
                  </h3>
                  <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                    {topic.excerpt}
                  </p>
                  <p className="mt-2 text-[11px] text-foreground-500">
                    {topic.category} · {topic.readTime}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}